/* hs-eslint ignored failing-rules */
/* eslint-disable conversations/no-dynamic-i18n */

import { PureComponent } from 'react';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { getDynamicNamespace } from 'conversations-infrastructure/i18n/getDynamicNamespace';
import { READ, SENT } from 'conversations-message-history/constants/messageDeliveryStatuses';
import { jsx as _jsx } from "react/jsx-runtime";
export default class DeliveryStatusTag extends PureComponent {
  render() {
    const {
      deliveryStatus,
      timestamp
    } = this.props;
    const messageKey = getDynamicNamespace({
      prefix: 'conversations-inbox-message-history.delivery-status',
      translationOptions: [READ, SENT]
    }, deliveryStatus);
    return /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: messageKey,
        options: {
          timestamp: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: timestamp,
            format: "LT",
            type: "userTz"
          })
        }
      })
    });
  }
}
DeliveryStatusTag.displayName = 'DeliveryStatusTag';